import { MetricCard } from 'components/features/schedule-of-values/metric-card';
import SubmissionCurrencyTab from 'components/features/submission-currency-tabs';
import { DEFAULT_CONVERSION_CURRENCY } from 'components/features/submission-details/types';
import FormLayoutGroup from 'components/ui/form-layout-group';
import FormSection from 'components/ui/form-section';
import { ECurrencies } from 'constants/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ClaimBinderDetails: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(
    DEFAULT_CONVERSION_CURRENCY
  );

  return (
    <div>
      <SubmissionCurrencyTab
        originalCurrency={ECurrencies.AUD}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        className="flex justify-end"
      />
      <FormSection
        title={t('claim.binderClaimsActions.claimBinderDetails.title')}
        collapsible
      >
        <FormLayoutGroup mdColumns={2}>
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguMarketLossIndemnity'
            )}
            value={'0'}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.totalIncurredCosts'
            )}
            value={'0'}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguNetIndemnityPayments'
            )}
            value={'0'}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguNetCostPayments'
            )}
            value={'0'}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.fguMarketLossOutstandingIndemnity'
            )}
            value={'0'}
          />
          <MetricCard
            title={t(
              'claim.binderClaimsActions.claimBinderDetails.totalOutstandingCosts'
            )}
            value={'0'}
          />
        </FormLayoutGroup>
      </FormSection>
    </div>
  );
};

export default ClaimBinderDetails;
